<script setup lang="ts">
	import { useBasePrinter } from './BasePrinter.js';
	import SymIcon from "@fd/helpers/SymIcon.vue";

	const props = defineProps({
		value: String,
		style: String,
		styleClass: String,	
	//styleId: String,
		//link: String,
		//linkTarget: String,
		//tooltip: String,
		sortStyle: Object,
		rowValue: Boolean
	});

	const {hasLink, tdStyle} = useBasePrinter(props);
		
</script>
<template>
<td :class="styleClass" :style="[sortStyle, tdStyle]">
	<sym-icon v-if="rowValue" name="yes"/>
</td>
</template>
